import { FieldState } from "@is/types/checkout";

export type SignUpFormState = {
  firstName?: FieldState;
  lastName?: FieldState;
  phoneNumber?: FieldState;
  email?: FieldState;
};

export enum SignUpInputFields {
  FirstName = "firstName",
  LastName = "lastName",
  PhoneNumber = "phoneNumber",
  Email = "email",
}
